/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Space_File_Content_TruncatedInputs */



/**
* | output |
* | --- |
* | "Shortened here; the whole text is written." |
*
* @param {Chat_Space_File_Content_TruncatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_space_file_content_truncated = /** @type {((inputs?: Chat_Space_File_Content_TruncatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Space_File_Content_TruncatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hier gekürzt; geschrieben wird der ganze Text.")
	return /** @type {LocalizedString} */ ("Shortened here; the whole text is written.")
});